/** 페이지 로더·QR 중앙 로고 (public/assets/images) */
export const LOADER_LOGO_URL = '/assets/images/log_s.png'
